import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getVoicesUsage } from "../Api/voicesUsage";
import { VoicesUsage, VoicesUsageFilters } from "../Models/voicesUsage";

export const useVoicesUsage = (filters: VoicesUsageFilters) => {
  return useQuery<VoicesUsage, Error>({
    queryKey: ["voicesUsage", filters],
    queryFn: () => getVoicesUsage(filters),
    placeholderData: keepPreviousData,
  });
};
